export enum FAVORITE_OPERATION_TYPE {
  SURGICAL = 'SURGICAL', // 수술
  NONSURGICAL = 'NONSURGICAL', // 시술
  UNKNOWN = 'UNKNOWN', // 모름
  BOTH = 'BOTH', // 양쪽다 관심
}
export interface UserOperationType {
  operationType: FAVORITE_OPERATION_TYPE
}
